import React, { useState, useRef, Fragment } from 'react';
import { Box, Button, Card, CardContent, IconButton, TextField, Typography } from '@mui/material';
import Formulario from 'components/formulario';
import { Add, AddCircleOutline, Delete } from '@mui/icons-material';
import { functions } from 'constantes/functions';

const OPCIONES_TIPO_MEDIO_ALTERNATIVO = [{ id: 1, name: 'Vallas' }, { id: 2, name: 'Páginas web' }];
const PATRON_URL = /^(https?:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/[\w\-./?%&=+#~]*)?$/i;

const ELEMENTOS_INICIALES = (manejarCambio, prevValues = {}) => ({
    tipoExteriorTitle: {
        idelement: "tipoExteriorTitle", title: 'Seleccione tipo de medio alternativo', position: "center",
        value: "", isError: false, elementType: 'titulo', showTitleForm: true, name: "tipoExteriorTitle",
    },
    tipoMedioAlternativo: {
        idelement: "tipoMedioAlternativo", value: prevValues.tipoMedioAlternativo || null, label: "Seleccione una opción *", pattern: "^[1-9]$",
        validators: ['required'], errorMessages: ['Seleccione el tipo de medio alternativo'], isError: false,
        elementType: 'autoCompletar', list: OPCIONES_TIPO_MEDIO_ALTERNATIVO,
        autoFocus: true, isRequired: true, width: '100%', handler: manejarCambio,
    },
});

const ELEMENTOS_VALLA = (manejarCambio, prevValues = {}) => ({
    ...ELEMENTOS_INICIALES(manejarCambio, prevValues),
    tipoMedioAlternativo: {
        ...ELEMENTOS_INICIALES(manejarCambio, prevValues).tipoMedioAlternativo,
        value: prevValues.tipoMedioAlternativo || null,
    },
    tipoValla: {
        idelement: "tipoValla", value: prevValues.tipoValla || null, label: "Tipo de valla *",
        pattern: "^[1-9][0-9]*$", validators: ['required'], errorMessages: ['Seleccione el tipo de valla'],
        isError: false, elementType: 'autoCompletar',
        list: [{ id: 4, name: 'Vallas digitales' }, { id: 5, name: 'Vallas fijas' }, { id: 6, name: 'Vallas móviles' }],
        autoFocus: false, isRequired: true, width: '100%', showSelectAutoComplete: true,
    },
    autorizacionMunicipalTitle: {
        idelement: "autorizacionMunicipalTitle", title: 'Tiene autorización municipal', position: "center",
        value: "", isError: false, elementType: 'titulo', showTitleForm: true, name: "autorizacionMunicipalTitle",
    },
    autorizacionMunicipal: {
        idelement: "autorizacionMunicipal", value: prevValues.autorizacionMunicipal || null, label: "Seleccione una opción *",
        isError: false, elementType: 'radio', errorMessages: ['Debe seleccionar una opción'],
        options: [{ value: "1", label: 'Si' }, { value: "0", label: 'No' }], disabled: false, isRequired: true, width: '100%',
    },
});

const nuevoLink = () => ({ id: Date.now() + Math.random(), value: '', error: false, errorMessage: '' });

const Exterior = ({ agregarAlListado }) => {

    const tipoSeleccionadoRef = useRef(0);
    const linksRef = useRef([nuevoLink()]);

    const [tipoSeleccionado, setTipoSeleccionado] = useState(0);
    const [links, setLinksState] = useState(linksRef.current);

    const setLinks = (updaterOrValue) => {
        const next = typeof updaterOrValue === 'function' ? updaterOrValue(linksRef.current) : updaterOrValue;
        linksRef.current = next;
        setLinksState(next);
    };

    const manejarCambioTipoMedioAlternativo = (event) => {
        const tipo = Number(event?.target?.value || 0);
        const textoTipo = event?.target?.text;
        const tipoSeleccionadoObjeto = tipo > 0
            ? { id: tipo, name: textoTipo || OPCIONES_TIPO_MEDIO_ALTERNATIVO.find((item) => item.id === tipo)?.name || '' }
            : null;

        tipoSeleccionadoRef.current = tipo;
        setTipoSeleccionado(tipo);
        setLinks([nuevoLink()]);
        if (tipo === 1) {
            setElements(ELEMENTOS_VALLA(manejarCambioTipoMedioAlternativo, { tipoMedioAlternativo: tipoSeleccionadoObjeto }));
        } else {
            setElements(ELEMENTOS_INICIALES(manejarCambioTipoMedioAlternativo, { tipoMedioAlternativo: tipoSeleccionadoObjeto }));
        }
    };

    const [elements, setElements] = useState(() => ELEMENTOS_INICIALES(manejarCambioTipoMedioAlternativo));

    const agregarLink = () => {
        setLinks((prev) => [...prev, nuevoLink()]);
    };

    const actualizarLink = (id, value) => {
        setLinks((prev) => prev.map((item) => item.id === id ? { ...item, value, error: false, errorMessage: '' } : item));
    };

    const eliminarLink = (id) => {
        setLinks((prev) => prev.filter((item) => item.id !== id));
    };

    const addToTheList = async (dataForm) => {
        const esPaginaWeb = tipoSeleccionadoRef.current === 2;

        if (esPaginaWeb) {
            const currentLinks = linksRef.current;
            let hayError = false;
            const linksValidados = currentLinks.map((item) => {
                const valor = item.value.trim();
                let errorMessage = '';

                if (!valor) {
                    errorMessage = 'Este campo es requerido';
                } else if (!PATRON_URL.test(valor)) {
                    errorMessage = 'Ingrese un link valido. Ejemplo: https://www.tse.org.gt';
                }

                if (errorMessage) hayError = true;
                return { ...item, error: !!errorMessage, errorMessage };
            });

            if (hayError) {
                setLinks(linksValidados);
                return;
            }

            const enlacesPaginasWeb = linksValidados.map((item) => item.value.trim()).filter(Boolean);
            agregarAlListado({ ...dataForm, enlacesPaginasWeb });
        } else {
            agregarAlListado({ ...dataForm, enlacesPaginasWeb: [] });
        }

        tipoSeleccionadoRef.current = 0;
        setTipoSeleccionado(0);
        setLinks([nuevoLink()]);
        const reiniciados = functions.reiniciarEstadoDelFormulario(ELEMENTOS_INICIALES(manejarCambioTipoMedioAlternativo));
        setElements({ ...reiniciados });
    };

    const [buttonList] = useState({
        "addToTheList": {
            "label": "Agregar al listado", "icon": <Add />, "callback": addToTheList, "loading": false, "size": "medium",
            "background": "linear-gradient(45deg, #ffcc00 30%, #d9bd09 90%)", "border": "0px", "borderRadius": "3",
            "boxShadow": "0 3px 5px 2px rgba(168, 142, 50, .3)", "color": "white", "height": 37, padding: "0 30px", disabled: false, isCancel: false,
        },
    });

    const esPaginaWeb = tipoSeleccionado === 2;
    const buttonListFormulario = esPaginaWeb ? {} : buttonList;

    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elements}
                        buttonList={buttonListFormulario}
                    />
                    {esPaginaWeb && (
                        <Box style={{ marginTop: '8px' }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '10px' }}>
                                Links de páginas web
                            </Typography>
                            {links.map((link, index) => (
                                <Box key={link.id} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '8px' }}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        label={index === 0 ? 'Link de la página web *' : `Link ${index + 1} *`}
                                        value={link.value}
                                        onChange={(e) => actualizarLink(link.id, e.target.value)}
                                        error={link.error}
                                        helperText={link.error ? link.errorMessage : ''}
                                    />
                                    {index === 0 && (
                                        <IconButton
                                            onClick={agregarLink}
                                            color="primary"
                                            title="Agregar otro link"
                                            style={{ marginTop: '2px' }}
                                        >
                                            <AddCircleOutline />
                                        </IconButton>
                                    )}
                                    {links.length > 1 && (
                                        <IconButton
                                            onClick={() => eliminarLink(link.id)}
                                            color="error"
                                            title="Eliminar este link"
                                            style={{ marginTop: '2px' }}
                                        >
                                            <Delete />
                                        </IconButton>
                                    )}
                                </Box>
                            ))}
                            <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                                <Button
                                    variant="contained"
                                    onClick={() => addToTheList({ tipoMedioAlternativo: { id: 2, name: 'Páginas web' } })}
                                    style={{
                                        color: buttonList.addToTheList.color,
                                        background: buttonList.addToTheList.background,
                                        border: buttonList.addToTheList.border,
                                        borderRadius: buttonList.addToTheList.borderRadius,
                                        boxShadow: buttonList.addToTheList.boxShadow,
                                        height: buttonList.addToTheList.height,
                                        padding: buttonList.addToTheList.padding,
                                    }}
                                    size={buttonList.addToTheList.size}
                                >
                                    <Add style={{ marginRight: '8px' }} />
                                    Agregar al listado
                                </Button>
                            </Box>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default Exterior;